// Small pieces Setup › Memory's tabs share (RECALL-ADMIN-MEMORY).
import { InfoTip } from "@companyos/ui";

export const WAITING = "Waiting on memory service";

/** The quiet note for a part that needs the memory service (an (i) tells why). */
export function WaitingNote({ what }: { what?: string }) {
  return (
    <span
      className="inline-flex items-center gap-1 text-xs text-muted-foreground"
      data-slot="admin-waiting"
    >
      {WAITING}
      {what ? ` · ${what}` : ""}
      <InfoTip label="About waiting on the memory service">
        The memory service has not opened this for admins yet. Nothing is lost: what is shown comes
        from what agents told memory, and this switches on by itself once it opens.
      </InfoTip>
    </span>
  );
}
